/* layer Event
 * @namespace layer
 * @example
 * layer.open(target) = layer open;
 * layer.close = layer close;
 */
const layerModule = ( () => {
    let _target;

    const open = (target, callFn) => {
        _target = $("." + target);
        _target.fadeIn();

        if(callFn !== undefined){
            callFn();
        }
    }

    const close = () => {
        if(_target === undefined){
            _target = $(".js_layer");
        }
        _target.fadeOut();
    }

    return {
        open : open,
        close : close
    }
});

//$(document).ready(() => {
//    new layerModule();
//});

window.Layer = layerModule();
export default layerModule;